import Link from "next/link";
import Image from "next/image";
import { useCallback, useState } from "react";
import fetchHeaderFooterData from "@/hooks/fetchHeaderFooterData";
import { MEDIA_BASE_URL } from "@/utils/api";
import { TARGET } from "@/utils/constants";
import { debounce } from "lodash";
import { uid } from "@/utils/generic";

const NavLinks = ({ customClass, data }) => {
  const [num, setNum] = useState(0);
  const [dropDown, setDropDown] = useState(true);

  const [checkLastMenu, setCheckLastMenu] = useState(false);

  // get header api data
  const { headerApiData } = fetchHeaderFooterData();
  const mainMenu = headerApiData.main_menu ? headerApiData.main_menu : [];

  const mediaBaseUrl = MEDIA_BASE_URL;

  // Define a mapping object for routes and queries
  const routeMapping = {
    bathware: {
      pathname: "/bathware/bathware-listing",
      query: (name) => ({
        category: name,
        from_header: "yes",
      }),
    },
  };

  const menuHandler = (i) => {
    setNum(i);
  };

  const handleMouseEnter = (sub_menus) => {

    setNum(0);
    setDropDown(true);
    // const checkMenu = sub_menus.map((item) => item.sub_menus);

    // for (let i = 0; i < checkMenu.length; i++) {
    //   if (checkMenu[i].length > 0) {
    //     setCheckLastMenu(false);
    //     break;
    //   } else {
    //     setCheckLastMenu(true);
    //   }
    // }
    const hasSubMenus = sub_menus.some(item => item.sub_menus.length > 0);
    setCheckLastMenu(!hasSubMenus);
    return hasSubMenus;
  };



  const closeMenuHandler = () => {
    // e.preventDefault();

    setDropDown(false);
  };

  const tileMenuHandler = (e) => {
    console.log("func running");
  };

  // console.log('mainMenu', mainMenu);

  return (
    <>
    {mainMenu && <ul
      className={`lg:flex justify-center lg:justify-between *:uppercase *:lg:text-[1vw] *:font-primary lg:gap-x-[2vw] *:lg:py-[1vw] main-nav min-h-1 ${customClass}`} 
    >
      {mainMenu?.map((item, index) => {
        return (
          
            <li
              key={item.id}
              onMouseEnter={() => handleMouseEnter(item.sub_menus)}
              className={`mainNavList ${checkLastMenu == true ? "relative mainList" : "mainBigList"
                }`}
            >
              <Link href={item.slug ? `${item.slug}` : ""} className="relative">
                {item.name}{" "}
                {item.sub_menus && item.sub_menus.length != 0 && (
                  <span
                    className={`absolute left-[50%] translate-x-[-50%] top-[1.8vw] z-10 w-[1.5vw]`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="37"
                      height="15"
                      viewBox="0 0 37 15"
                      fill="none"
                      className="w-full"
                    >
                      <path
                        d="M18.5005 0.245605L36.0413 14.8772H0.959667L18.5005 0.245605Z"
                        fill="#212121"
                      />
                    </svg>
                  </span>
                )}
              </Link>
              {item.sub_menus && item.sub_menus.length != 0 && (
                <div
                  className={`dropdown absolute w-full w-full-new min-w-[200px] left-0 top-[3.45vw] flex max-h-[80vh] overflow-auto ${dropDown ? "openDropDown" : "closeDropDown"
                    }`}
                >

                  {
                    item.sub_menus[num] && item.sub_menus[num].name != "" && (
                      <ul className="w-[15%] leftTab bg-[#363435]">
                        {item.sub_menus.length > 0 &&
                          item.sub_menus.map((childItem, i) => (
                            <li
                              key={childItem.id}
                              className={`p-[1.1vw] ${i == num && childItem.sub_menus.length > 0
                                ? "bg-[#212121]"
                                : ""
                                }`}
                              onClick={(e) => menuHandler(i)}
                            >
                              {/* <Link href={childItem.slug ? `${childItem.slug}` : ""}> {childItem.name} </Link> */}

                              {item.sub_menus[i].sub_menus.length == 0 ? (
                                <Link
                                  href={
                                    routeMapping[item.name.toLowerCase()]
                                      ? {
                                        pathname:
                                          routeMapping[item.name.toLowerCase()]
                                            .pathname,
                                        query: routeMapping[
                                          item.name.toLowerCase()
                                        ].query(childItem.name),
                                      }
                                      : childItem?.slug?.includes("https")
                                        ? childItem.slug
                                        : `${childItem.slug}` ?? ""
                                  }
                                  target={
                                    childItem?.slug?.includes("https")
                                      ? TARGET.BLANK
                                      : TARGET.SELF
                                  }
                                  onClick={closeMenuHandler}
                                >
                                  {childItem.name}
                                </Link>
                              ) : (
                                <a>{childItem.name}</a>
                              )}
                            </li>
                          ))}
                      </ul>
                    )
                  }

                  {
                    item.sub_menus[num] &&
                    item.sub_menus[num].sub_menus.length != 0 && (
                      <ul
                        className={`w-full grid gap-[2.5vw] p-[2.5vw] max-h-[430px] lg:max-h-[35vw] overflow-auto ${item.sub_menus[num].name == ""
                          ? "grid-cols-5"
                          : "grid-cols-5"
                          }`}
                      >
                        {item.sub_menus &&
                          item.sub_menus.length != 0 &&
                          item.sub_menus[num] &&
                          item.sub_menus[num].sub_menus &&
                          item.sub_menus[num].sub_menus.map((lastItem, i) => {
                            return (
                              <li key={i}>
                                <Link
                                  onClick={closeMenuHandler}
                                  // href={`/tiles?look_and_feel=concrete&page=1`}
                                  href={`${lastItem.slug}`}
                                  passHref
                                >
                                  <Image
                                    src={`${mediaBaseUrl}${lastItem.thumbnail}`}
                                    // src={`https://simpolo.kwebmaker.in/uploads/menu/thumbnail_1421778731_1722417626.webp`}
                                    // src={`/images/tiles/location/${lastItem.imgSrc}`}
                                    width={500}
                                    height={450}
                                    alt={lastItem.name}
                                    className="mb-[1vw] h-[150px] object-cover"
                                  />
                                </Link>
                                <Link
                                  href={`${lastItem.slug}`}
                                  passHref
                                >
                                  <div className="text-white">{lastItem.name}</div>
                                </Link>
                              </li>)
                          })}
                      </ul>
                    )
                  }
                </div>
              )}
            </li>

          
        );
      })}
    </ul>
    }
    </>
  );
};

export default NavLinks;